<template>
  <app-popup
    :active.sync="isActive" title="Квартиры, у которых не все счетчики введены в эксплуатацию"
    width="100%"
    class="employee-not-all-devices-commissioned-popup"
  >
    <div class="employee-not-all-devices-commissioned-popup__header">
      <div class="ml-auto">
        <div class="link-icon employee-not-all-devices-commissioned-popup__export" @click="exportTable">
          <app-icon name="DownloadFile" />
        </div>
      </div>
    </div>
    <div class="employee-not-all-devices-commissioned-popup__content">
      <grid-infinite-scroll
        ref="table"
        :columns="tableColumns"
        :getData="updateValues"
        :maxConcurrentDatasourceRequests="4"
        :rowHeight="50"
        :pageSize="20"
        key="valueTable"
        :filterable="false"
        :sortable="false"
        noRowsText="Квартиры не найдены"
      />
    </div>
  </app-popup>
</template>

<script>
import AccountNumberRenderer        from "@/components/employee/accounts/AccountNumberRenderer";
import DeviceTypeRenderer           from "@/components/calculated-program/metering/DeviceTypeRenderer";
import StatusRenderer               from "@/components/calculated-program/metering/StatusRenderer";
import NotCommissionedTypesRenderer from "@/components/calculated-program/metering/NotCommissionedTypesRenderer";

export default {
  name: "NotAllDevicesCommissionedPopup",
  data() {
    return {
      isActive:        false,
      monthCount:      1,
      monthCountError: false,
      deviceTypes:     [],
    };
  },
  computed: {
    windowWidth() {
      return this.$store.getters['windowWidth'];
    },
    tableColumns() {
      return [
        {
          headerName:            'Счет',
          field:                 'account_number',
          minWidth:              120,
          editable:              false,
          sortable:              true,
          filter:                true,
          cellRendererFramework: AccountNumberRenderer,
          cellRendererParams:    ( { data } ) => data,
        },
        {
          headerName:  'Помещение',
          field:       'number',
          filter:      true,
          editable:    false,
          minWidth:    120,
          valueGetter: ( cell ) => cell.data.number,
        },
        {
          headerName:   'Собственник',
          field:        'b_owner',
          filter:       false,
          editable:     false,
          minWidth:     120,
          cellRenderer: ( { value } ) => {
            const text = value || '-';
            return `<span title="${text}">${text}</span>`;
          },
        },
        {
          headerName:  'Телефон',
          field:       'phone',
          minWidth:    100,
          flex:        2,
          editable:    false,
          filter:      false,
          valueGetter: ( { data } ) => {
            const { owners_u_a } = data;
            if (!owners_u_a) return '-';
            return owners_u_a.reduce(( phones, owner ) => {
              const { user: { telephone } } = owner;
              if (telephone) phones.push(telephone.toString());
              return phones;
            }, []).join(', ') || '-';
          },
        },
        {
          headerName:            'Не введенные счетчики',
          field:                 'no_devices_list',
          filter:                false,
          editable:              false,
          flex:                  2,
          minWidth:              120,
          cellRendererFramework: NotCommissionedTypesRenderer,
          cellRendererParams:    ( { data } ) => data,
          valueGetter:           ( { data } ) => {
            if (Array.isArray(data.no_devices_list)) {
              return data.no_devices_list.map(deviceType => this.$store.getters['common/devices/typeById'](deviceType).name).join(" | ");
            }
            return "";
          },
        },
      ];
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    exportTable() {
      this.$vs.loading();
      this.$refs.table.exportRows('Квартиры, у которых не все счетчики введены в эксплуатацию');
    },
    open() {
      this.isActive = true;
    },
    updateData() {
      if (Number(this.monthCount) < 1) {
        this.monthCountError = true;
        return false;
      } else {
        this.$refs.table.resetData();
      }
    },
    updateValues( page, filters, orderBy ) {
      let params = {
        orderby:      orderBy,
        filters:      filters,
        page:         page,
        buildings_id: this.selectedHouseId,
      };
      return this.$http.get('apartments_with_no_device', { params }).then(( { data } ) => {
        this.$vs.loading.close();
        return {
          response: data,
          data:     data.data,
          total:    data.total,
        };
      });
    },
    getDeviceTypesById( id ) {
      let deviceType = this.deviceTypes.find(deviceType => Number(deviceType.id) === Number(id));
      return deviceType ? deviceType.name : 'Неизвестное устройство';
    },
    getDeviceTypes() {
      return new Promise(async resolve => {
        let { data } = await this.$http.get('devices_type');
        this.deviceTypes = data;
        resolve(data);
      });
    },
  },
  mounted() {
    this.getDeviceTypes();
  },
};
</script>

<style lang="scss">
.employee-not-all-devices-commissioned-popup {
  .modal__body {
    height: 100%;
  }

  .modal__content {
    display: flex;
    flex-direction: column;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    flex-shrink: 0;
  }

  &__export {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
}
</style>
